import React from 'react';
import { string } from 'prop-types';
import { NavLink } from 'react-router-dom';
import i18next from 'i18next';

import logo from '~assets/mercat.svg';

import styles from './styles.module.scss';

function Logo({ homePath }) {
  return (
    <NavLink to={homePath}>
      <img className={styles.logo} src={logo} alt={i18next.t('App:kdsLogo')} />
    </NavLink>
  );
}

Logo.propTypes = {
  homePath: string.isRequired
};

export default Logo;
